import type { RecommendationStrategyProfile } from './lineupRecommendationEngine';

export type TeamRecommendationSettings = {
  enforce_target_matches?: boolean | null;
  target_match_variance?: number | null;
  enforce_max_sit?: boolean | null;
  max_weeks_without_match?: number | null;
  use_partner_compatibility?: boolean | null;
  use_partner_scheduling_preferences?: boolean | null;
};

/**
 * Applies the captain-facing, team-owned settings to the engine's internal
 * defaults. A legacy strategy can still supply non-UI defaults during the
 * compatibility period, but it cannot override these team values.
 */
export function applyTeamRecommendationSettings(
  strategy: RecommendationStrategyProfile,
  settings: TeamRecommendationSettings | null | undefined,
): RecommendationStrategyProfile {
  if (!settings) return strategy;
  return {
    ...strategy,
    enforceTargetMatches: settings.enforce_target_matches === true,
  targetMatchVariance: Math.max(0, Math.floor(Number(settings.target_match_variance ?? 1) || 0)),
    enforceMaxSit: settings.enforce_max_sit === true,
    maxWeeksWithoutMatch: settings.max_weeks_without_match ?? 2,
    usePartnerCompatibility: settings.use_partner_compatibility !== false,
    usePartnerSchedulingPreferences: settings.use_partner_scheduling_preferences !== false,
  };
}
